<template>
    <!-- SECTION: Template -->
    <div class="sub-page">
        <!-- ANCHOR: PageTitle -->
        <PageTitle
            :main-title="this.$t('sampleBadgesV3.section1.texts.text1-1')"
            :sub-title="this.$t('sampleBadgesV3.section1.texts.text1-2')"
            bg-color="yellow3"
        />

        <!-- ANCHOR: 문의하기 -->
        <section class="c-section bg-yellow3 d-flex justify-center">
            <div class="c-contanier">
                <v-row
                    class="d-flex justify-center"
                    no-gutters
                >
                    <v-col class="pt-0 pb-0">
                        <p
                            class="le-text-subtitle2 text-center"
                            v-html="this.$t('sampleBadgesV3.section1.texts.text2-1')"
                        >
                        </p>
                    </v-col>
                </v-row>

                <div
                    class="d-flex align-center justify-center"
                    :class="{
                        'py-12': $vuetify.breakpoint.smAndUp,
                        'py-15': $vuetify.breakpoint.xsOnly                    
                    }"
                >
                    <div 
                        class="bg-white1 rounded-pill d-flex align-center justify-center"
                        :style="{
                            width: $vuetify.breakpoint.xs ? '328px' : '430px',
                            height: $vuetify.breakpoint.xs ? '328px' : '430px'
                        }"
                    >
                        <a
                            href="https://wallet-kr.openbadge.net/search/achievement/6835ecc2-f9ad-8aef-8f39-0197ecba34af"
                            target="_blank"
                            class="d-flex"
                        >
                            <object
                                type="image/svg+xml"
                                class="no-pointer-events"
                                :data="require('@/assets/svg/others/issuing-sample-badgeV3.svg')"
                                :width="$vuetify.breakpoint.mdAndUp ? 288 : ($vuetify.breakpoint.smOnly ? 288 : 220)"
                            >Your browser does not support SVG</object>
                        </a>
                    </div>
                </div>

                <p
                    class="le-text-subtitle2 text-center"
                    v-html="this.$t('sampleBadgesV3.section1.texts.text2-2')"
                >
                </p>
                
                <p
                    class="le-heading5 text-center"
                    :class="{
                        'pt-25 pb-12': $vuetify.breakpoint.smAndUp,
                        'pt-15 pb-7': $vuetify.breakpoint.xsOnly
                    }"
                >
                    {{ this.$t('sampleBadgesV3.section1.texts.text2-2_1') }}
                </p>

                <!-- ANCHOR: Form-문의하기 -->
                <div>
                    <v-form ref="form">
                        <!-- 이름 -->
                        <v-row
                            no-gutters
                            class="d-flex flex-column justify-center align-center"
                        >
                            <v-col
                                cols="10"
                                md="4"
                                sm="8"
                                class="text-center mb-3 le-text-body3"
                            >
                                <p
                                    class="mb-12"
                                    v-html="this.$t('sampleBadgesV3.section1.texts.text2-3')"
                                >
                                </p>
                            </v-col>

                            <v-col
                                cols="10"
                                md="4"
                                sm="8"
                                class="pb-0 pt-0 mb-2"
                            >
                                <p class="contact_title mb-3">
                                    <strong class="le-text-subtitle3">{{ this.$t('sampleBadgesV3.section1.texts.text2-4') }}</strong>
                                    <span class="le-text-body2 text-red1 ml-1">*</span>
                                </p>

                                <v-text-field
                                    v-model="name"
                                    :rules="[v => !!v || this.$t('sampleBadgesV3.section1.errors.text1')]"
                                    outlined
                                    color="blue1"
                                    :dense="$vuetify.breakpoint.smAndDown"
                                ></v-text-field>
                            </v-col>
                        </v-row>

                        <!-- 이메일 -->
                        <v-row
                            no-gutters
                            class="d-flex flex-column justify-center align-center"
                        >
                            <v-col
                                cols="10"
                                md="4"
                                sm="8"
                                class="pb-0 pt-0 mb-2"
                            >
                                <p class="contact_title mb-3">
                                    <strong class="le-text-subtitle3">{{ this.$t('sampleBadgesV3.section1.texts.text2-5') }}</strong>
                                    <span class="le-text-body2 text-red1 ml-1">*</span>
                                </p>

                                <v-text-field
                                    v-model="email"
                                    :rules="[
                                        v => !!v || this.$t('sampleBadgesV3.section1.errors.text2'),
                                        v => /.+@.+\..+/.test(v) || this.$t('sampleBadgesV3.section1.errors.text3')
                                    ]"
                                    outlined
                                    color="blue1"
                                    placeholder="info@lecos.co.kr"
                                    :dense="$vuetify.breakpoint.smAndDown"
                                ></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row class="mt-10">
                            <v-col class="d-flex align-center justify-center pt-0 pb-0">
                                <v-btn
                                    color="orange1"
                                    :large="$vuetify.breakpoint.smAndUp"
                                    depressed
                                    class="text-white1"
                                    @click="showIssuingCheckDialogVisible"
                                >
                                    {{ this.$t('sampleBadgesV3.section1.btns.btn1') }}
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-form>
                </div>

                <!-- ANCHOR: 절차 -->
                <p
                    class="le-heading5 text-center"
                    :class="{
                        'py-25': $vuetify.breakpoint.smAndUp,
                        'py-15': $vuetify.breakpoint.xsOnly
                    }"
                >
                    {{ this.$t('sampleBadgesV3.section2.texts.text1-1') }}
                </p>

                <v-row class="d-flex justify-center align-center proccess">
                    <v-col
                        cols="12"
                        md="10"
                        sm="10"
                    >
                        <v-row>
                            <v-col
                                cols="6"
                                md="3"
                                class="d-flex flex-column justify-center align-center"
                            >
                                <div>
                                    <v-img
                                        :src="require('@/assets/img/issuing-sample-process-1.png')"
                                        :width="$vuetify.breakpoint.mdAndUp ? 190 : ($vuetify.breakpoint.xsOnly ? 117 : 190)"
                                        :height="$vuetify.breakpoint.mdAndUp ? 190 : ($vuetify.breakpoint.xsOnly ? 117 : 190)"
                                        alt=""
                                    />
                                </div>

                                <p
                                    class="le-text-subtitle2 proccess__label"
                                    :class="{
                                        'mt-10': $vuetify.breakpoint.smAndUp,
                                        'mt-5': $vuetify.breakpoint.xsOnly
                                    }"
                                    v-html="this.$t('sampleBadgesV3.section2.texts.text2-1')"
                                >
                                </p>
                            </v-col>
                            <v-col
                                cols="6"
                                md="3"
                                class="d-flex flex-column justify-center align-center"
                            >
                                <div>
                                    <v-img
                                        :src="require('@/assets/img/issuing-sample-process-2.png')"
                                        :width="$vuetify.breakpoint.mdAndUp ? 190 : ($vuetify.breakpoint.xsOnly ? 117 : 190)"
                                        :height="$vuetify.breakpoint.mdAndUp ? 190 : ($vuetify.breakpoint.xsOnly ? 117 : 190)"
                                        alt=""
                                    />
                                </div>

                                <p
                                    class="le-text-subtitle2 proccess__label"
                                    :class="{
                                        'mt-10': $vuetify.breakpoint.smAndUp,
                                        'mt-5': $vuetify.breakpoint.xsOnly
                                    }"
                                    v-html="this.$t('sampleBadgesV3.section2.texts.text2-2')"
                                >
                                </p>
                            </v-col>
                            <v-col
                                cols="6"
                                md="3"
                                class="d-flex flex-column justify-center align-center"
                            >
                                <div>
                                    <v-img
                                        :src="require('@/assets/img/issuing-sample-process-3.png')"
                                        :width="$vuetify.breakpoint.mdAndUp ? 190 : ($vuetify.breakpoint.xsOnly ? 117 : 190)"
                                        :height="$vuetify.breakpoint.mdAndUp ? 190 : ($vuetify.breakpoint.xsOnly ? 117 : 190)"
                                        alt=""
                                    />
                                </div>

                                <p
                                    class="le-text-subtitle2 proccess__label"
                                    :class="{
                                        'mt-10': $vuetify.breakpoint.smAndUp,
                                        'mt-5': $vuetify.breakpoint.xsOnly
                                    }"
                                    v-html="this.$t('sampleBadgesV3.section2.texts.text2-3')"
                                >
                                </p>
                            </v-col>
                            <v-col
                                cols="6"
                                md="3"
                                class="d-flex flex-column justify-center align-center"
                            >
                                <div>
                                    <v-img
                                        :src="require('@/assets/img/issuing-sample-process-4.png')"
                                        :width="$vuetify.breakpoint.mdAndUp ? 190 : ($vuetify.breakpoint.xsOnly ? 117 : 190)"
                                        :height="$vuetify.breakpoint.mdAndUp ? 190 : ($vuetify.breakpoint.xsOnly ? 117 : 190)"
                                        alt=""
                                    />
                                </div>

                                <p
                                    class="le-text-subtitle2 proccess__label"
                                    :class="{
                                        'mt-10': $vuetify.breakpoint.smAndUp,
                                        'mt-5': $vuetify.breakpoint.xsOnly
                                    }"
                                    v-html="this.$t('sampleBadgesV3.section2.texts.text2-4')"
                                >
                                </p>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>

                <v-row
                    no-gutters
                    class="text-center"
                    :class="{
                        'pt-25': $vuetify.breakpoint.smAndUp,
                        'pt-15': $vuetify.breakpoint.xsOnly
                    }"
                >
                    <v-col>
                        <p class="le-text-subtitle2">
                            {{ this.$t('sampleBadgesV3.section2.texts.text3-1') }} 
                            <a
                                href="https://concise-boat-d4b.notion.site/LecoS-OPEN-Badges-3-0-21ebe54b98a380168064fed89be41367?source=copy_link"
                                target="_blank"
                                rel="noopener noreferrer"
                                class="text-blue3 l-text-button d-inline-flex"
                            ><span class="text">{{ this.$t('sampleBadgesV3.section2.texts.text3-2') }}</span></a>{{ this.$t('sampleBadgesV3.section2.texts.text3-3') }}
                        </p>
                    </v-col>
                </v-row>

                <v-row class="mt-15">
                    <v-col class="d-flex align-center justify-center pt-0 pb-0">
                        <v-btn
                            :to="{ name: 'HomePageSelectedLanguage' }"
                            color="orange1"
                            :large="$vuetify.breakpoint.smAndUp"
                            depressed
                            class="text-white1"
                            exact
                        >
                            {{ this.$t('sampleBadgesV3.section2.btns.btn1') }}
                        </v-btn>
                    </v-col>
                </v-row>
            </div>
        </section>

        <!-- ANCHOR: 다이얼로그-입력확인 -->
        <template>
            <v-dialog
                v-model="isIssuingCheckDialogVisible"
                width="500"
            >
                <v-card class="pa-0 rounded-lg">
                    <div class="le-heading6 pa-5">
                        {{ this.$t('sampleBadgesV3.section3.texts.text1') }}
                    </div>

                    
                    <div
                        v-if="isIssuingSuccessLoading"
                        class="center-absolute"
                    >
                        <v-progress-circular
                            indeterminate
                            color="orange1"
                            size="60"
                            width="10"
                        ></v-progress-circular>
                    </div>

                    <div
                        class="le-text-body2 pl-5 pr-6"
                        style="min-height: 88px;"
                    >
                        <p class="mb-3">
                            {{ this.$t('sampleBadgesV3.section3.texts.text2') }}
                        </p>

                        <strong>{{ name }}</strong><br>
                        <strong>{{ email }}</strong><br>
                        
                        <p class="mt-3">
                            {{ this.$t('sampleBadgesV3.section3.texts.text3') }}
                        </p>
                    </div>

                    <div class="pa-5 d-flex justify-end gap-3">
                        <v-btn
                            v-ripple="{ class: 'text-blue3' }"
                            color="blue1"
                            outlined
                            :small="$vuetify.breakpoint.smAndDown"
                            depressed
                            class="text-white1"
                            @click="handleIssuingCheckDialogClose"
                        >
                            {{ this.$t('sampleBadgesV3.section3.btns.btn1') }}
                        </v-btn>

                        <v-btn
                            color="orange1"
                            :small="$vuetify.breakpoint.smAndDown"
                            depressed
                            class="text-white1"
                            :class="{'disabled': isIssuingSuccessLoading }"
                            @click="handleSubmit"
                        >
                            {{ this.$t('sampleBadgesV3.section3.btns.btn2') }}
                        </v-btn>
                    </div>
                </v-card>
            </v-dialog>
        </template>

        <!-- ANCHOR: 다이얼로그-발행완료 -->
        <template>
            <v-dialog
                v-model="isIssuingSuccessDialogVisible"
                width="500"
            >
                <v-card class="pa-0 rounded-lg">
                    <div class="le-heading6 pa-5">
                        {{ this.$t('sampleBadgesV3.section4.texts.text1') }}
                    </div>

                    <div
                        class="le-text-body2 pl-5 pr-6"
                        style="min-height: 88px;"
                        v-html="this.$t('sampleBadgesV3.section4.texts.text2')"
                    >
                    </div>

                    <div class="pa-5 d-flex justify-end gap-3">
                        <v-btn
                            color="orange1"
                            :small="$vuetify.breakpoint.smAndDown"
                            depressed
                            class="text-white1"
                            @click="handleIssuingSuccessDialogClose"
                        >
                            {{ this.$t('sampleBadgesV3.section4.btns.btn1') }}
                        </v-btn>
                    </div>
                </v-card>
            </v-dialog>
        </template>
    </div>
    <!-- !SECTION: Template -->
</template>

<script>
import { mapActions } from 'vuex';
// import { getSampleBadgesMetaInfo } from '@/utils/metaInfo.js';
import PageTitle from '@/components/PageTitle.vue';

export default {
    name: 'SampleBadgesPage',
    components: {
        PageTitle
    },

    // metaInfo() {
    //     return getSampleBadgesMetaInfo(this);
    // },

    // SECTION: Data Properties
    data: function () {
        return {
            isIssuingSuccessLoading: false,
            isIssuingCheckDialogVisible: false,
            isIssuingSuccessDialogVisible: false,
            lang: 'ko-KR',
            name: '',
            email: '',
        };
    },
    // !SECTION: Data Properties

    // SECTION: Lifecycle Hooks
    created() {
        // 라우트 기반으로 lang 세팅 (예: /eng/... -> en-US, /kor/... -> ko-KR)
        this.lang = this.resolveAcceptLang();
    },

    mounted() {
        //
    },

    beforeDestroy() {
        //
    },
    // !SECTION: Lifecycle Hooks

    // SECTION: Methods
    methods: {
        ...mapActions(
            'issuing', [ 'issueBadgeV3' ]
        ),

        // --- lang 자동 감지 (페이지 prefix 기준) ---
        resolveAcceptLang() {
            const p = (this.$route?.path || '').toLowerCase();
            if (p.startsWith('/eng')) return 'en-US';
            if (p.startsWith('/kor')) return 'ko-KR';
            return 'ko-KR';
        },

        /* ============================================================
         * ANCHOR: 발행하기 버튼 클릭
         * ============================================================ */
        showIssuingCheckDialogVisible() { 
            // 유효성 검사
            if (!this.$refs.form.validate()) {
                console.log('validate!!');
                return;
            }
            this.isIssuingCheckDialogVisible = true;
        },

        handleIssuingCheckDialogClose() {
            this.isIssuingCheckDialogVisible = false;
        },

        /* ============================================================
         * ANCHOR: 네(발행하기) 버튼 클릭
         * ============================================================ */
        async handleSubmit() {
            // this.handleIssuingCheckDialogClose();
            // this.isIssuingSuccessDialogVisible = true;

            this.isIssuingSuccessLoading = true;

            try {
                // 유효성 검사
                // if (!this.$refs.form.validate()) {
                //     console.log('validate!!');
                //     return;
                // }

                const { lang, name, email } = this;

                this.issueBadgeV3({ name, email, lang })
                    .then(res => {
                        console.log('res', res);

                        if (res.status === 200) {
                            this.isIssuingSuccessLoading = false;
                            // this.$router.push({ name: 'ContactUsFinishPage' });
                            this.handleIssuingCheckDialogClose();
                            this.isIssuingSuccessDialogVisible = true;
                            this.$nextTick(() => {
                                this.name = undefined;
                                this.email = undefined;
                            });
                        } else {
                            // 실패 처리
                            alert(`오류 발생: ${res.data}. 다시 시도해 주세요.`);
                            this.isIssuingSuccessLoading = false;
                        }
                    }).catch((error) => {
                        this.isIssuingSuccessLoading = false;

                        if (error.response) {
                            // 요청이 이루어졌으며 서버가 2xx의 범위를 벗어나는 상태 코드로 응답했습니다.
                            console.log(error.response.data);
                            console.log(error.response.status);
                            console.log(error.response.headers);

                            alert('오류 발생. 다시 시도해 주세요.');
                                    
                            // this.errMsg = error.response.request;
                            // this.activeModalErr = true;
                            // console.log('errMsg', this.errMsg);
                        }
                        else if (error.request) {
                            // 요청이 이루어 졌으나 응답을 받지 못했습니다.
                            // `error.request`는 브라우저의 XMLHttpRequest 인스턴스 또는
                            // Node.js의 http.ClientRequest 인스턴스입니다.
                            console.log(error.request);

                            alert('오류 발생. 다시 시도해 주세요.');

                            // this.errMsg = error.request;
                            // this.activeModalErr = true;
                        }
                        else {
                            // 오류를 발생시킨 요청을 설정하는 중에 문제가 발생했습니다.
                            console.log('Error', error.message);

                            this.errMsg = error.message;
                            this.activeModalErr = true;
                        }
                        console.log(error.config);
                    }).finally(() => { 
                        console.log('end');
                        // this.$refs['btnIssuing'].disabled = false;
                    });

                // API 호출
                // const response = await this.issueBadgeV3({
                //     lang: this.lang,
                //     name: this.name,
                //     email: this.email
                // });               

                // console.log('response.data.result', response.data);

                // if (response.data.result === 'Requested') { 
                //     this.handleIssuingCheckDialogClose();
                //     this.isIssuingSuccessDialogVisible = true;
                //     console.log('완료!');
                // }
            } catch (error) {
                this.handleError(error);
            } finally {
                console.log('Request completed');
                // 필요에 따라 버튼 비활성화 복원 등
                // this.$refs['btnInquery'].disabled = false;
            }
        },
        handleError(error) {
            // 에러 핸들링 함수
            if (error.response) {
                // 요청이 이루어졌으나 에러 응답을 받은 경우
                console.error('Error Response Data:', error.response.data);
                console.error('Error Response Status:', error.response.status);
                console.error('Error Response Headers:', error.response.headers);
                alert('서버 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.');
                this.isIssuingSuccessLoading = false;
            } else if (error.request) {
                // 요청이 이루어졌으나 응답이 없는 경우
                console.error('Error Request:', error.request);
                alert('서버와의 연결에 실패했습니다. 인터넷 연결을 확인해 주세요.');
                this.isIssuingSuccessLoading = false;
            } else {
                // 요청 설정 중 오류가 발생한 경우
                console.error('Error Message:', error.message);
                alert('오류가 발생했습니다. 다시 시도해 주세요. 지속적인 오류 발생 시 관리자에게 문의해 주세요.');
                this.isIssuingSuccessLoading = false;
            }
            console.error('Error Config:', error.config);
        },
        /* ============================================================
         * ANCHOR: 확인 버튼 클릭 (발행 완료)
         * ============================================================ */
        handleIssuingSuccessDialogClose() {
            this.isIssuingSuccessDialogVisible = false;
            this.resetForm();
        },
        resetForm() {
            this.name = '';
            this.email = '';
            this.$refs.form.resetValidation();
        },
    },
    // !SECTION: Methods
};
</script>
